export const profileRouteRoot = '/profile'

export const profileRoute = {
  mainInfo: '/main-info',
  password: '/password',
}
